import React, { useRef, useEffect, useState } from 'react';
import "./DataViz.css";
import HeapObject from "./HeapObject";
import {assert, generateHeapObjID, isPrimitiveType} from "../../util/TraceUtil";
import {getRefID, renderPrimitiveObject} from "./RenderUtil";
import jsplumb from 'jsplumb';
import {renderCStructArray} from "./RenderUtilC";
const jsPlumbIn = jsplumb.jsPlumb;
const connectorHighlightColor = '#e93f34';
const connectorBaseColor = '#005583';
const connectorInactiveColor = '#cccccc';
export default ({curEntry, curTraceLayout, lang}) => {
  const containerRef = useRef(null);
  const rootArr = [];
  const connectionMap = new Map();
  curTraceLayout?.forEach(([_, id]) => {
    rootArr.push(id);
  })

  useEffect(() => {
    const jsPlumbInstance = jsPlumbIn.getInstance({
      Container: containerRef.current,
      Endpoint: ["Dot", {radius:3}],
      EndpointStyles: [{fill: connectorBaseColor},{fill: ""}],
      Anchors: ["RightMiddle", "LeftMiddle"],
      PaintStyle: {lineWidth:1, stroke: connectorBaseColor},
      Connector: ["Bezier", { curviness: 30  }],
      Overlays: [[ "Arrow", { length: 10, width:7, foldback:0.55, location:1 }]],
      EndpointHoverStyles: [{fill: connectorHighlightColor}],
      HoverPaintStyle: {lineWidth: 1, stroke: connectorHighlightColor},

    });
    if (!curEntry){
      return;
    }
    const headerRect = document.getElementById("heapHeader").getBoundingClientRect()
    connectionMap.forEach((tar, src) => {
      const srcNode = document.getElementById(src);
      const tarNode = document.getElementById(tar);
      if (!tarNode){
        srcNode.innerHTML = '<span class="invalidPtr" title="无效指针">\uD83D\uDC80</span>'
        return;
      }else{
        srcNode.innerHTML = '&nbsp;'
      }
      // 连接前处理缩进
      //先重置margin todo 处理缩进
      // const parentElements = document.querySelectorAll('.toplevelHeapObject');
      // const allFirstLevelChildren = [];
      // parentElements.forEach(parent => {
      //   allFirstLevelChildren.push(...parent.children);
      // });
      // allFirstLevelChildren.forEach(child => {
      //     child.style.marginLeft = "0px";
      // })
      //再添加margin
      if (tarNode && srcNode && src.startsWith("v1__heap_") && tarNode.parentNode.classList.contains('toplevelHeapObject')) {
        let srcRect = srcNode.getBoundingClientRect();
        // console.log(src, srcRect)
        let oldMargin = 0
        if (tarNode.style?.marginLeft){
          oldMargin = parseInt(tarNode.style.marginLeft.replaceAll("px", ""))
        }
        tarNode.style.marginLeft = Math.max(oldMargin,(srcRect.left - headerRect.left + 32)) + "px";
      }
      setTimeout(() => {
        // 连接两个节点
        jsPlumbInstance.connect({
          source: srcNode,
          target: tarNode,
        });
        jsPlumbInstance.select().each(function(c) {
          const stackFrameDiv = c.source.closest('.stackFrame:not(.highlightedStackFrame)');
          if (! stackFrameDiv) {
            return;
          }
          const srcId = stackFrameDiv?.id
          if (!srcId.startsWith("v1__heap_")){
            c.setPaintStyle({lineWidth: 1, stroke: connectorInactiveColor});
            c.endpoints[0].setPaintStyle({fill: connectorInactiveColor});
          }
        })
      }, 0)
    })


    // 清理函数，防止重复初始化
    return () => {
      jsPlumbInstance.deleteEveryEndpoint();
      jsPlumbInstance.reset();
    };
  }, [curEntry]);

  const renderNestedObjectFrame = (frame, varname) => {
    const obj = frame.encoded_locals[varname]
    return renderNestedObject(obj, frame, varname)
  }
  const renderNestedObject = (obj, frame, varname) => {

    if (isPrimitiveType(obj)) {
      return renderPrimitiveObject(obj, connectionMap)
    }
    //todo c++相关 pytutor.js 2559行

    if (obj[0] === 'REF') {
      //指针
      let objId = getRefID(obj);
      if (rootArr.includes(objId)) {
        let srcId = `v1__${frame.unique_hash}__${varname}`;
        let tarId = generateHeapObjID(objId);
        connectionMap.set(srcId, tarId)
        return <div className="stack_pointer" id={srcId}>&nbsp;</div>
      }
      return (<></>);
    } else {
      assert(obj[0] === 'C_STRUCT' || obj[0] === 'C_UNION' || obj[0] === 'C_ARRAY' || obj[0] === 'C_MULTIDIMENSIONAL_ARRAY');
      return renderCStructArray(obj, renderNestedObject, lang);
    }

  }
  const renderVarName = (varname) => {
    if (varname === '__return__')
      return <span className="retval">Return<br/>value</span>
    else
      return (<>{varname}</>);

  }

  return (
    <>
      <div id="dataViz" ref={containerRef} style={{position: "relative"}}>
        <table id="stackHeapTable">
          <tbody>
          <tr>
            <td id="stack_td">
              <div id="globals_area">
                <div id="stackHeader">Frames</div>
                {curEntry?.ordered_globals?.length > 0 && <div className={`stackFrame ${curEntry?.stack_to_render?.length ? "" : "highlightedStackFrame"}`}
                     id="v1__globals">
                  <div id="v1__globals_header" className="stackFrameHeader">Global frame</div>
                  <table className="stackFrameVarTable" id="v1__global_table">
                    <tbody>
                    {
                      curEntry?.ordered_globals?.map((global_name, index) => (
                        <tr key={index} className="variableTr" id={"v1__global_" + global_name + "_tr"}>
                          <td className="stackFrameVar">{global_name}</td>
                          <td className="stackFrameValue">
                            {renderNestedObjectFrame({encoded_locals: curEntry.globals, unique_hash: "global"}, global_name)}
                          </td>
                        </tr>
                      ))
                    }
                    </tbody>
                  </table>
                </div>}
              </div>
              <div id="stack">
                {curEntry?.stack_to_render?.map((frame, i) => (

                  <div key={i} className={`stackFrame ${frame?.is_highlighted && "highlightedStackFrame"}`}
                       id={"v1__stack" + i} data-frame_id={frame.frame_id}>
                    <div className="stackFrameHeader">{frame.func_name}</div>
                    <table className="stackFrameVarTable">
                      <tbody>
                      {frame.ordered_varnames?.map((varname, i) => (
                        <tr key={varname} className="variableTr" id={`v1__${frame.unique_hash}__${varname}_tr`}>
                          <td className="stackFrameVar">{renderVarName(varname)}</td>
                          <td className="stackFrameValue">{renderNestedObjectFrame(frame, varname)}</td>
                        </tr>
                      ))}

                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            </td>
            <td id="heap_td">
              <div id="heap">
                <div id="heapHeader">Objects</div>
                <HeapObject heap={curEntry?.heap} rootArr={rootArr} connectionMap={connectionMap} lang={lang}/>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div id="connections">
        </div>
      </div>
    </>


  );
};